import forecastingImage from '../images/PST-Forecasting-01.jpg';
import backcastingImage from '../images/PST-Backcasting-01.jpg';
import knowledgeImage from '../images/PST-Knowledge-01.jpg';
import './Home.css';
import {Link} from 'react-router-dom'


function Home() {

    return (
        <div className="text-center">
            <div className="album py-5 bg-light">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <p className="intro">The <strong>LEVITATE Policy Support Tool (PST)</strong>, which has been produced within the LEVITATE European research project, funded within the Horizons 2020 Programme of the European Commission,
                            is the go-to, one-stop-shop to support decisions on Cooperative, Connected and Automated Mobility (CCAM) related interventions. It is designed as an open access, web-based
                            system that provides interested users with access to LEVITATE methodologies and results. Its detailed design takes into account the specific needs of the key stakeholders and it provides access to related bibliography,
                                project results, documentation of tools and methods, excerpts from CCAM guidelines, as well as a Decision Support System with forecasting and backcasting capabilities.</p>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                        <div className="col">
                            <div className="card shadow-sm">
                                <Link to="/pst">
                                <img src={forecastingImage} className="promo-img" />
                                    <div className="card-body">
                                        <h3>FORECASTING</h3>
                                        <p className="card-text">The forecasting module, with the accompanying
                                            CBA sub-system, provides quantified and/or monetized output on the
                                            expected impacts of automation and CCAM related policies, featuring
                                            customizability of parameter quantities.</p>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        <div className="col">
                            <div className="card shadow-sm">
                                <Link to="/back_casting">
                                    <img src={backcastingImage} className="promo-img"/>
                                    <div className="card-body">
                                        <h3>BACKCASTING</h3>
                                        <p className="card-text">The backcasting module enables users to identify the sequences of CCAM
                                            measures that are expected to result in their desired policy
                                            objectives and monetize their implementation.</p>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        <div className="col">
                            <div className="card shadow-sm">
                                <Link to="/knowledge">
                                    <img src={knowledgeImage} className="promo-img" />
                                    <div className="card-body">
                                        <h3>KNOWLEDGE</h3>
                                        <p className="card-text">The Knowledge module contains the repository
                                            and recommendations of the LEVITATE project, including documentation
                                            of the project toolbox, results of the various methods, relevant
                                            literature from CCAM guidelines.</p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-5">
                    </div>
                    <div className="row info">
                        <div className="col">
                            <p className="intro">
                                To help users understand the PST’s functions and results, we have developed <a target="_blank" href="https://www.youtube.com/watch?v=eFv6pKwGhrs&list=PLtYQif034Fw_7EovsvWJ-Aq2uqYT68ygo"> short tutorial videos </a> and two challenge questions with answers to get comfortable with the tool.
                            </p>
                            <p className="intro">
                                Once you have had the opportunity to try the PST, we would be grateful if you filled in <a target="_blank" href="https://forms.gle/wizZzVr9kQFRPjD18">this brief survey</a> to provide feedback.
                                This would help us evaluate the usability of the tool and make any necessary adaptations.
                            </p>
                            <p className="intro">
                                For further information on LEVITATE, see the project website: <a target="_blank" href="https://levitate-project.eu/">https://levitate-project.eu/</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Home;
